module.exports = __webpack_public_path__ + "img/3_46.a24ecc47.png";